"use strict";

Shopify.theme.jsQuotePopup = {
  init: function init($section) {
    Shopify.theme.jsQuotePopup = $.extend(this, Shopify.theme.getSectionData($section));
    
    this.$section = $section
    this.$trigger = $section.find('[data-quote-popup-trigger]')
    this.$popup = $section.find('[data-quote-popup]')
    this.$close = $section.find('.popup__close')
    this.$overlay = $('.body-overlay-wrapper')
    
    this.$trigger.on('click',function(){
    	this.open()
    }.bind(this))
    
    this.$close.on('click',function(){
    	this.close()
    }.bind(this))
    
    this.$overlay.on('click',function(){
    	this.close()
    }.bind(this))
    
  },
  open: function open() {
    let _self = this;
    if(_self.$popup.hasClass('is-active'))_self.close();
    
    _self.$overlay.addClass('is-active')
    _self.$popup.addClass('is-active')

  },
  close: function close() {
    let _self = this;
    if(!_self.$popup.hasClass('is-active'))return;
    
    _self.$popup.removeClass('is-active')
    _self.$overlay.removeClass('is-active')
  },
  showThemeEditorState: function showThemeEditorState() {
    $('.popup-section').addClass('is-fixed-top'); // Prevent scroll to bottom
    this.open();
  },
  hideThemeEditorState: function hideThemeEditorState() {
    $('.popup-section').removeClass('is-fixed-top');
    this.close();
  },
  unload: function unload($section) {
    $.fancybox.destroy();
    $('.popup-modal .fancybox-slide').empty();
    $('.popup__close').off();
  }
};


document.querySelectorAll(".popup__close").forEach((button) => {
  button.addEventListener("click", () => {
    document.querySelector('[data-quote-popup]').classList.remove("is-active");
    document.querySelector('.body-overlay-wrapper').classList.remove("is-active");
  });
});
